import { Component, OnInit, ViewChild } from "@angular/core";
import * as _ from "underscore";
import * as moment from "moment";
import { ToastService } from "../../components/toast/toast.service";
import { DeleteConfirmationModalComponent } from "../../components/modal/modals/delete-confirmation-modal.component";
import { LowyGridComponent } from "../../components/grid/grid.component";
import { User } from "../../models/user.model";
import { EditUserModalComponent } from "./edit-user-modal.component";
import { UserService } from "../../services/user.service";

@Component({
  templateUrl: "./manage-users.component.html",
  styleUrls: ["manage-users.component.scss"],
  providers: [UserService],
})
export class ManageUsersComponent implements OnInit {
  @ViewChild("grid") grid: LowyGridComponent;
  @ViewChild("editUserModal") editUserModal: EditUserModalComponent;
  @ViewChild("deleteUserModal")
  deleteUserModal: DeleteConfirmationModalComponent;

  // we end up with index 0 being the selectAll checkbox, and the rows starting at i=1, see html
  public checkboxes: Array<{
    isChecked: boolean;
    attachment: any;
    element: any;
  }>;

  public users: User[];

  constructor(
    private toastService: ToastService,
    private userService: UserService
  ) {}

  public async editUser(user: User) {
    this.editUserModal.open(user);
  }

  public async deleteUser(user: User) {
    this.deleteUserModal.open({
      data: user,
      headline: "Delete " + user.name,
      subheading: "Are you sure you want to delete user " + user.name + "?",
    });
  }
  public async confirmDeleteUser(user: User) {
    try {
      await this.userService.deleteUser(user.userId);
      this.toastService.throwToast("User deleted");
      this.ngOnInit();
    } catch (err) {
      this.toastService.throwToast("Error deleting user: " + err);
    }
  }

  async ngOnInit() {
    this.users = await this.userService.getUsers();
    this.grid.dataReady(
      this.users,
      ["checkbox", "name", "email", "role", "siteId"],
      ["checkbox", "Name", "Email", "Role", "Site"]
    );
  }

  public async downloadAllRecords(downloadType: string) {
    this.grid.downloadFiles(downloadType, this.users);
  }
}



// WEBPACK FOOTER //
// ./src/app/home/manage-users/manage-users.component.ts